import { render, staticRenderFns } from "./homeHerder.vue?vue&type=template&id=50f8f7fa&scoped=true"
import script from "./homeHerder.vue?vue&type=script&lang=js"
export * from "./homeHerder.vue?vue&type=script&lang=js"
import style0 from "./homeHerder.vue?vue&type=style&index=0&id=50f8f7fa&prod&lang=scss&scoped=true"
import style1 from "./homeHerder.vue?vue&type=style&index=1&id=50f8f7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8f7fa",
  null
  
)

export default component.exports